import '../common/_commonjsHelpers-64249c85.js';
import { r as react } from '../common/index-3eed8459.js';
import '../common/tslib.es6-a8e14131.js';
import { u as useUpdate, a as useMemoizedFn } from '../common/index-94c03f8f.js';
import '../common/polyfill-node:global-21e5c503.js';
import { q as queryString } from '../common/index-48cdf8cc.js';
import '../common/setPrototypeOf-8347dfab.js';
import '../common/inheritsLoose-dc562014.js';
import '../common/index-5b42cf28.js';
import '../common/extends-1379b0c5.js';
import '../common/history-dad51d84.js';
import { t as tmp } from '../common/react-router-97a8f38a.js';
import '../common/hoist-non-react-statics.cjs-35f67ccf.js';
import '../common/objectWithoutPropertiesLoose-fe69c3b9.js';

// ignore waring `"export 'useNavigate' (imported as 'rc') was not found in 'react-router'`
const rc = tmp;
const baseParseConfig = {
  parseNumbers: false,
  parseBooleans: false
};
const baseStringifyConfig = {
  skipNull: false,
  skipEmptyString: false
};
const useUrlState = (initialState, options) => {
  var _a, _b;
  const {
    navigateMode = 'push',
    parseOptions,
    stringifyOptions
  } = options || {};
  const mergedParseOptions = Object.assign(Object.assign({}, baseParseConfig), parseOptions);
  const mergedStringifyOptions = Object.assign(Object.assign({}, baseStringifyConfig), stringifyOptions);
  const location = rc.useLocation();
  // react-router v5
  const history = (_a = rc.useHistory) === null || _a === void 0 ? void 0 : _a.call(rc);
  // react-router v6
  const navigate = (_b = rc.useNavigate) === null || _b === void 0 ? void 0 : _b.call(rc);
  const update = useUpdate();
  const initialStateRef = react.useRef(typeof initialState === 'function' ? initialState() : initialState || {});
  const queryFromUrl = react.useMemo(() => {
    return queryString.parse(location.search, mergedParseOptions);
  }, [location.search]);
  const targetQuery = react.useMemo(() => Object.assign(Object.assign({}, initialStateRef.current), queryFromUrl), [queryFromUrl]);
  const setState = s => {
    const newQuery = typeof s === 'function' ? s(targetQuery) : s;
    // 1. 如果 setState 后，search 没变化，就需要 update 来触发一次更新。比如 demo1 直接点击 clear，就需要 update 来触发更新。
    // 2. update 和 history 的更新会合并，不会造成多次更新
    update();
    if (history) {
      history[navigateMode]({
        hash: location.hash,
        search: queryString.stringify(Object.assign(Object.assign({}, queryFromUrl), newQuery), mergedStringifyOptions) || '?'
      }, location.state);
    }
    if (navigate) {
      navigate({
        hash: location.hash,
        search: queryString.stringify(Object.assign(Object.assign({}, queryFromUrl), newQuery), mergedStringifyOptions) || '?'
      }, {
        replace: navigateMode === 'replace',
        state: location.state
      });
    }
  };
  return [targetQuery, useMemoizedFn(setState)];
};

export default useUrlState;
